export default __webpack_public_path__ + "static/media/me_working2.ba51d0e3.png";